import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import HeaderBlock from '../../primitives/HeaderBlock'

import { Wrapper } from './Supporters.styles'

const Supporters = ({ logos, headerText, pad, inverse, maxW }) => {
  return (
    <HeaderBlock
      inverse={inverse}
      headerText={headerText}
      maxGraphicWidth={maxW || 1600}
      pad={pad || '8rem 0 8rem'}
      graphic={
        !!logos && (
          <Wrapper>
            {logos.map((img, i) => (
              <GatsbyImage key={`supporter-${i}`} loading="eager" image={img} alt="Supporter" />
            ))}
          </Wrapper>
        )
      }
    />
  )
}

Supporters.propTypes = {
  logos: PropTypes.array.isRequired,
}

export default Supporters
